export const isAuthenticated = () => {
    let token = localStorage.getItem('token');

    return token;
};